import React from 'react';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import { FieldInput } from '../../../ui/FieldInput';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const SubfolderManager: React.FC<Props> = ({ value, onChange }) => {
  return (
      <section className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden w-full">
        <header className="flex items-center gap-3 p-4 sm:p-5 border-b border-gray-200">
          <CreateNewFolderOutlinedIcon className="text-gray-500" />
          <h1 className="text-lg font-medium text-gray-900">
            Подпапка для результатов экзамена
          </h1>
        </header>

        <div className="p-4 sm:p-6">
          <FieldInput
            label="Название подпапки (необязательно)"
            placeholder="Например, 'Экзамены_Лето_2025'"
            value={value}
            onChange={onChange}
          />
        </div>
      </section>
  );
};